import classNames from 'classnames'
import React, { ReactNode } from 'react'

import { Accordion, AccordionItem, AccordionItemProps } from '../accordion/accordion.js'
import { Button, ButtonProps } from '../button/button.js'
import { Image, ImageProps } from '../image/image.js'

export interface UpgradeCardProps {
    button: ButtonProps
    image: ImageProps
    title: string
    content: ReactNode
    accordionItems?: AccordionItemProps[]
    className?: string
}

export const UpgradeCard = (props: UpgradeCardProps): JSX.Element => {
    const { accordionItems, button, image, title, content } = props

    const className: string = classNames('upgrade-card', props.className)

    return (
        <div className={className}>
            <div className="upgrade-card__inner">
                <div className="upgrade-card__image-wrapper">
                    <Image {...image} className="upgrade-card__image image--full" />
                </div>
                <h2 className="upgrade-card__title text-large bold">{title}</h2>
                {typeof content === 'string' ? <p>{content}</p> : content}
                {accordionItems && (
                    <Accordion>
                        {accordionItems.map((item: AccordionItemProps, index: number) => (
                            <AccordionItem {...item} className="upgrade-card__accordion-item" key={index} />
                        ))}
                    </Accordion>
                )}
                <Button {...button} isBlock={true} variant="secondary" />
            </div>
        </div>
    )
}
